<div mat-dialog-title>
  <div class="modal__header">
    <div class="modal__title">
      <h1>Creating new entries for library items linked to ratecard.</h1>
    </div>

    <button
      class="close-button"
      mat-dialog-close>
      <mat-icon class="material-symbols-rounded">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content
  aria-label="Generic modal"
  class="modal-container md-dialog-container generic-modal">
  <div class="px-10 pb-4 w-full generic-modal__content">
    <div class="mt-2">
      <span>
        Some roles in the library entries don't match the roles in the new ratecard version. Please map the roles below:
      </span>
    </div>

    <div class="mt-4">
      <map-roles
        [sourceRateCard]="data.sourceRateCard"
        [ratecard]="data.targetRateCard"
        [mappingRoles]="data.mappingRoles"
        [targetRoles]="data.targetRoles">
      </map-roles>
    </div>
  </div>

  <div class="d-flex d-flex-justify-end px-10 pt-8 pb-4">
    <div class="generic-modal__buttons">
      <button
        mat-button
        mat-dialog-close>
        Cancel
      </button>
      <button
        class="main-action-button ml-4"
        mat-button
        (click)="onConfirm()">
        Confirm
      </button>
    </div>
  </div>
</mat-dialog-content>
